import * as React from 'react';

/**
 * @description OficeProgramms icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { OficeProgramms } from '@sravni/design-system-icons'
 *
 * <OficeProgramms />
 * ```
 */
const OficeProgramms = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "OficeProgramms", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M15.701 5.035 13.187 2.52A1.778 1.778 0 0 0 11.931 2H5.555c-.982 0-1.777.796-1.777 1.778v12.444c0 .982.795 1.778 1.777 1.778h8.89c.982 0 1.777-.796 1.777-1.778v-9.93c0-.472-.187-.924-.52-1.257v0Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M16.222 6.444h-3.555a.89.89 0 0 1-.89-.888V2M10 9.111v6.222M6.444 12.222h7.111M12.667 15.333H7.333a.89.89 0 0 1-.889-.889V10a.89.89 0 0 1 .89-.889h5.333a.89.89 0 0 1 .888.889v4.444a.89.89 0 0 1-.888.89Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { OficeProgramms };
//# sourceMappingURL=OficeProgramms.js.map
